<template>
    <div v-tippy="{ content: title, hideOnClick: false, trigger: title !== ''? 'mouseenter focus' : 'manual', placement: display === 'vertical' ? 'bottom' : 'right' }"
         :class="{ display }"
         class="toolbar-slot">
        <font-awesome-icon v-if="icon" :icon="icon"></font-awesome-icon>
        <slot></slot>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { directive as tippy } from 'vue-tippy'

export default defineComponent({
    name: 'ToolbarSlot',
    directives: {
        tippy
    },
    props: {
        display: {
            type: String,
            required: false,
            default: 'horizontal'
        },
        icon: {
            type: Array,
            required: false,
            default: null
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    }
})
</script>

<style lang="scss" scoped>
.toolbar-slot {
    --width: 46px;
    --height: 46px;

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: var(--width);
    height: var(--height);

    background-color: var(--default-color);

    font-size: calc(var(--height) / 3);
    color: var(--secondary-color);
    cursor: pointer;

    &.horizontal {
        border-bottom: 1px solid var(--divider-color);

        &:first-child {
            border-top: 1px solid var(--divider-color);
            border-radius: var(--radius) var(--radius) 0 0;
        }

        &:last-child {
            border-bottom: none;
            border-radius: 0 0 var(--radius) var(--radius);
        }
    }

    &.vertical {
        border-right: 1px solid var(--divider-color);

        &:first-child {
            border-left: 1px solid var(--divider-color);
            border-radius: var(--radius) 0 0 var(--radius);
        }

        &:last-child {
            border-bottom: none;
            border-radius: 0 var(--radius) var(--radius) 0;
        }
    }
}
</style>
